<template>
	<v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="960" scrollable>
		<v-card>
			<v-card-title class="d-flex align-center">
				配方 #{{ recipe?.id }} 匹配详情
				<v-spacer />
				<v-btn icon variant="text" @click="$emit('update:modelValue', false)">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text v-if="recipe && roast">
				<v-chip v-if="summary" size="small" :color="matchLevelColor(matchLevel)" variant="tonal" class="mb-3">
					{{ summary }}
				</v-chip>
				<recipe-offset-radar
					v-if="chartReady"
					:key="`${recipe?.id}-${roast?.id}`"
					:recipe="recipe"
					:roast="roast"
					:profile="profile"
					:active="chartReady"
				/>
				<v-alert v-if="!hasOffsets" type="info" variant="tonal" density="compact">
					暂无可比较的烘焙参数，请先完善曲线或完成出库数据。
				</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="$emit('update:modelValue', false)">关闭</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import RecipeOffsetRadar from './RecipeOffsetRadar.vue'
import { computeRecipeOffsets } from './recipeOffset.js'

export default {
	components: { RecipeOffsetRadar },
	props: {
		modelValue: Boolean,
		recipe: { type: Object, default: null },
		roast: { type: Object, default: null },
		profile: { type: Object, default: null },
		summary: { type: String, default: '' },
		matchLevel: { type: String, default: '' }
	},
	emits: ['update:modelValue'],
	data() {
		return {
			chartReady: false
		}
	},
	watch: {
		modelValue(open) {
			if (open) {
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						this.chartReady = true
					})
				})
			} else {
				this.chartReady = false
			}
		}
	},
	computed: {
		hasOffsets() {
			if (!this.recipe || !this.roast) return false
			return computeRecipeOffsets(this.recipe, this.roast, this.profile).offsets.length > 0
		}
	},
	methods: {
		matchLevelColor(level) {
			if (level === 'perfect') return 'success'
			if (level === 'good') return 'info'
			return 'warning'
		}
	}
}
</script>
